import { render, staticRenderFns } from "./PaBadge.vue?vue&type=template&id=50c59c8f"
import script from "./PaBadge.vue?vue&type=script&lang=js"
export * from "./PaBadge.vue?vue&type=script&lang=js"
import style0 from "./PaBadge.vue?vue&type=style&index=0&id=50c59c8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports